import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback,
  useReducer
} from "react";
import { postData } from "../common/utils";
import { decoratorArray } from "../common/decorator_comment";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import "draft-js/dist/Draft.css";
import arrowRight from "../../assets/images/arrow_right.png";
//Images
import pf_group from "../../assets/images/pf_group.png";
import pf_tag from "../../assets/images/pf_tag.png";
import pf_smile from "../../assets/images/pf_smile.png";
import pf_gif from "../../assets/images/pf_gif.png";
import pf_image from "../../assets/images/pf_image.png";
import pf_link from "../../assets/images/pf_link.png";

//Mention plugin
import Editor from "@draft-js-plugins/editor";
import "@draft-js-plugins/mention/lib/plugin.css";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";

//Export HTML plugin
import { stateToHTML } from "draft-js-export-html";

//React alert
import { useAlert } from "react-alert";

//Emoji
import createEmojiPlugin from '@draft-js-plugins/emoji';
import '@draft-js-plugins/emoji/lib/plugin.css';

var mentions = [];


var badges = [];
//console.log(EditorState);
fetch(process.env.REACT_APP_API_URL + "api/posts/hashtag")
  .then((response) => response.json())
  .then((data) => {
    badges = data;
  });
const emojiPlugin = createEmojiPlugin({
  // selectGroups: [{
  //   title: 'Society',
  //   icon: '👥',
  //   categories: ['people', 'food', 'travel','nature'],
  // }, {
  //   title: 'Objects & symbols',
  //   icon: '❤️',
  //   categories: ['objects', 'symbols'],
  // }]
});
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
const Comment = (props) => {
  //console.log("cmtprops",props);
  const [disable, setDisable] = React.useState(false);
  const alert = useAlert();
  const ref = useRef(null);
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );
  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/user/suggestions")
      .then((response) => response.json())
      .then((data) => (mentions = data));
  }, []);

  //#region Mention
  function mentionTest(props) {
    return (
      <span style={{ color: "#008bff", fontWeight: 600 }}>
        {props.decoratedText}
      </span>
    );
  }
  //Mention
  const [open, setOpen] = useState(false);
  const [contentHtml, setContentHtml] = useState('');

  const [suggestions, setSuggestions] = useState(mentions);
  /*
    const { MentionSuggestions, mentionPlugin } = useMemo(() => {
      const mentionPlugin = createMentionPlugin({
        mentionPrefix: "@",
        mentionTrigger: "@",
        mentionComponent: mentionTest,
      });
      const { MentionSuggestions } = mentionPlugin;
      return { mentionPlugin, MentionSuggestions };
    }, []);
  */
  const onOpenChange = useCallback((_open) => {
    setOpen(_open);
  }, []);
  const onSearchChange = useCallback(({ value }) => {
    setSuggestions(defaultSuggestionsFilter(value, mentions));
  }, []);
  const onAddMention = () => {
    //alert('mention selected');
  };
  //#endregion

  //#region Badges
  function badgeTest(props) {
    return (
      <span className="testing" style={{ color: "#b4b4b4", fontWeight: 600 }}>
        {props.decoratedText}
      </span>
    );
  }
  const [open_badges, setOpen_badges] = useState(false);
  const [suggestions_badges, setSuggestions_badges] = useState(badges);
  /*
  const { BadgeSuggestions, mentionPlugin_badges } = useMemo(() => {
    const mentionPlugin_badges = createMentionPlugin({
      mentionPrefix: "#",
      mentionTrigger: "#",
      mentionComponent: badgeTest,
    });
    const { MentionSuggestions: BadgeSuggestions } = mentionPlugin_badges;
    return { mentionPlugin_badges, BadgeSuggestions };
  }, []);
*/
  const onOpenChange_badges = useCallback((_open) => {
    setOpen_badges(_open);
  }, []);
  const onSearchChange_badges = useCallback(({ value }) => {
    setSuggestions_badges(defaultSuggestionsFilter(value, badges));
  }, []);
  const onAddMention_badges = () => {
    //alert('badge selected');
  };
  //#endregion
  const { MentionSuggestions, BadgeSuggestions, EmojiSuggestions, EmojiSelect, plugins } = useMemo(() => {
    const mentionPlugin = createMentionPlugin({
      mentionPrefix: "@",
      mentionTrigger: "@",
      mentionComponent: mentionTest,
    });
    const { MentionSuggestions } = mentionPlugin;

    const emojiPlugin = createEmojiPlugin();
    const { EmojiSuggestions, EmojiSelect } = emojiPlugin;

    const mentionPlugin_badges = createMentionPlugin({
      mentionPrefix: "#",
      mentionTrigger: "#",
      mentionComponent: badgeTest,
    });

    const { MentionSuggestions: BadgeSuggestions } = mentionPlugin_badges;
    // eslint-disable-next-line no-shadow
    const plugins = [mentionPlugin, mentionPlugin_badges, emojiPlugin];
    return { MentionSuggestions, BadgeSuggestions, EmojiSuggestions, EmojiSelect, plugins };
  }, []);
  /*  
  const {plugins} = useState(() => {
    const plugins = [mentionPlugin, mentionPlugin_badges, emojiPlugin];
    return {
      plugins
    };
  });
  */
  //Editor Plugins
  //  const plugins = [mentionPlugin, mentionPlugin_badges, emojiPlugin];

  const commentSubmit = () => {
    var contentState = editorState.getCurrentContent();
    //console.log("yess________________", contentState);
    //e.preventDefault();
    var commentJSON = JSON.stringify(convertToRaw(contentState));
    //console.log(commentJSON, "CommentJSON");
    var blocks = convertToRaw(contentState).blocks;
    //var commentString = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    var commentString = contentState.getPlainText().trim();
    var postHTML = stateToHTML(contentState);

    //All hashtags
    var allHashtags = commentString.match(/[#]\w+/g);
    allHashtags =
      allHashtags == null
        ? []
        : allHashtags.map((element) => {
          return element.substring(1);
        });

    //Get mention count for validation. Only one recipient of pats allowed. Get id of first recipient
    //Get all suggested hashtags/badges. Remove them from allHashtags(Random hashtags that were not suggested)
    var entities = convertToRaw(contentState).entityMap;
    //var mentionCount = 0;
    //var recipientID = 0;
    var recipientID = [];
    var suggestedHashtags = [];
    for (const entity in entities) {
      if (entities[entity].type == "mention") {
        //mentionCount++;
        recipientID.push(entities[entity].data.mention.id);
        // if (mentionCount == 1) {
        //   recipientID = entities[entity].data.mention.id;
        //   console.log("recipientid", recipientID)
        // }
      } else if (entities[entity].type == "#mention") {
        suggestedHashtags.push(entities[entity].data.mention);
        //Remove suggestedHashtag from allHashtags
        allHashtags = allHashtags.filter((element) => {
          return element !== entities[entity].data.mention.name;
        });
      }
    }
    function refreshPage(data) {
      alert.success(data.message);
      setTimeout(() => {
        window.location.reload(false);
      }, 1000)
    }

    //const hasDuplicates = (arr) => arr.length !== new Set(arr).size;

    //Check if post is empty
    if (commentString !== "") {
      var data = {
        recipientID: recipientID,
        allHashtags: allHashtags,
        suggestedHashtags: suggestedHashtags,
        commentJSON: commentJSON,
        postID: props.data.data.postID,
        commentString: commentString,
        postHTML: postHTML,
      };

      postData(
        process.env.REACT_APP_API_URL + "api/posts/comment",
        data
      ).then((data) => {
        if (data.issuccessful == true) {
          setDisable(true);
          setEditorState(EditorState.createEmpty());
          //setAllComments(data.comments);
          refreshPage(data);
        } else {
          alert.error(data.message);
        }
      });
    } else {
      alert.error("Please enter your comment!");
    }
  };
  //#endregion

  return (
    <div className="pf-wrap">
      <div className="pf-form-wrap" style={{ padding: "0", paddingTop: "10px important" }}>
        <div className="pf-input-wrap" style={{ display: "flex" }}>
          {/* <Editor editorState={editorState} onChange={setEditorState} /> */}
          <div
            className="pf-comment pf-input-1"
            onClick={() => {
              ref.current && ref.current.focus()
            }}
          >
            <Editor
              editorKey={"editor" + props.data.data.postID}
              editorState={editorState}
              onChange={setEditorState}
              ref={ref}
              decorators={decoratorArray}
              plugins={plugins}
              className="editor-text"
              placeholder="Write a comment...."
            />
            <MentionSuggestions
              open={open}
              onOpenChange={onOpenChange}
              suggestions={suggestions}
              onSearchChange={onSearchChange}
              onAddMention={onAddMention}
            />
            <BadgeSuggestions
              open={open_badges}
              onOpenChange={onOpenChange_badges}
              suggestions={suggestions_badges}
              onSearchChange={onSearchChange_badges}
              onAddMention={onAddMention_badges}
            />

          </div>

          <div className="pf-btn-wrap" style={{ border: "none", marginLeft: "10px", marginTop: "auto", padding: "0", paddingBottom: "5px" }}>
            <button type="submit" className="btn-comment" onClick={commentSubmit} disabled={disable}>
              <img src={arrowRight} alt="" />
            </button>
          </div>
        </div>
        <EmojiSuggestions />
        <div>
          <EmojiSelect />
        </div>
      </div>
    </div>
  );
};

export default Comment;
